import grapesjs from 'grapesjs';
import loadComponents from './components';
import loadBlocks from './blocks';

//
// Change this constant to something unique
//
export const blockRef = 'ApplyChanges';

export default grapesjs.plugins.add(`gjs-component-${blockRef}`, (editor, opts = {}) => {
    const c = opts;

    let defaults = {
        blockRef: blockRef,
        blockLabel: 'Apply Changes',
        blockCategory: 'Setpoint Controls',
        blockIcons: 'fa fa-check-circle-o',
        cls: {  // HTML class names you will use within the block/component
            buttonCls: `${blockRef}-button`,
            buttonDisabledCls: `${blockRef}-button-disabled`,
        }
    };

    // Load defaults
    for (let name in defaults) {
        if (!(name in c))
            c[name] = defaults[name];
    }

    // Add components
    loadComponents(editor, c);

    // Add components
    loadBlocks(editor, c);

});
